import { ReactNode } from 'react'
import { IconPaths, IconSize, KTSVG } from '../../../_metronic/helpers'
import { Button } from '../Button/Button'
import styles from './styles/DataTable.module.css'

type TableEmptyStateProps = {
  title: string
  description?: string
  /** Ícone do tema (IconPaths). Padrão: IconPaths.Search. */
  icon?: IconPaths
  /** Próximo passo (ex.: "Adicionar instituição" ou "Limpar filtros"). */
  action?: { label: string; onClick: () => void }
}

export const TableEmptyState = ({
  title,
  description,
  icon = IconPaths.Search,
  action,
}: TableEmptyStateProps) => (
  <div className={styles.empty}>
    <span className='text-gray-700' aria-hidden='true'>
      <KTSVG path={icon} size={IconSize.Medium} className='svg-icon-gray-700' />
    </span>
    <h3 className={styles.emptyTitle}>{title}</h3>
    {description && <p className={styles.emptyText}>{description}</p>}
    {action && (
      <Button variant='secondary-outline' className='mt-2' onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
)

type TableErrorStateProps = {
  title?: string
  description?: ReactNode
  onRetry?: () => void
}

export const TableErrorState = ({
  title = 'Não foi possível carregar os dados.',
  description = 'A conexão com o servidor falhou. Seus filtros foram mantidos.',
  onRetry,
}: TableErrorStateProps) => (
  <div role='alert' className={styles.error}>
    <span aria-hidden='true' className='d-flex flex-shrink-0'>
      <KTSVG path={IconPaths.Alert} className='svg-icon-2 svg-icon-danger' />
    </span>
    <div className={styles.errorBody}>
      <strong className='text-gray-900 fw-semibold'>{title}</strong>
      <span className='text-gray-700'>{description}</span>
    </div>
    {onRetry && (
      <Button variant='secondary-outline' onClick={onRetry}>
        Tentar novamente
      </Button>
    )}
  </div>
)

const WIDTHS = ['62%', '48%', '70%', '55%', '66%', '44%', '58%', '72%', '50%', '64%']

/** Linhas de esqueleto com o mesmo número de colunas da tabela. */
export const TableSkeletonRows = ({
  columns,
  rows = 10,
  className,
}: {
  columns: number
  rows?: number
  className?: string
}) => (
  <>
    {Array.from({ length: rows }, (_, r) => (
      <tr key={r} aria-hidden='true'>
        {Array.from({ length: columns }, (_, c) => (
          <td key={c} className={className}>
            <div className={styles.skeleton} style={{ width: WIDTHS[(r + c) % WIDTHS.length] }} />
            {c > 0 && (
              <div
                className={styles.skeletonLight}
                style={{ width: WIDTHS[(r + c + 3) % WIDTHS.length] }}
              />
            )}
          </td>
        ))}
      </tr>
    ))}
  </>
)
